document.addEventListener('page:loaded', function() {
  const siteHeader = document.querySelector('.site-header');
  function stickyHeader() {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition >= 185) {
        siteHeader.classList.add('go_sticky');
      } else {
        siteHeader.classList.remove('go_sticky');
      }
    });
  }
  stickyHeader();
});